var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.006,
    height: 40,
    viewBox: "0 0 40.006 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3558",
    "data-name": "Path 3558",
    d: "M-400.048,197.856a20,20,0,0,1-20.089,19.988A20,20,0,0,1-440.054,197.8a20,20,0,0,1,20.06-19.958A19.994,19.994,0,0,1-400.048,197.856Zm-16.908-3.614h-.641c-2.143,0-4.285,0-6.428,0-.692,0-1.1.325-1.12.846-.017.561.387.884,1.125.885q3.127,0,6.253,0h.631a3.189,3.189,0,0,1-3.117,2.258c-1.207.028-2.415.008-3.623.009-.455,0-.922,0-1.168.478-.229.449.007.819.242,1.189q2.562,4.04,5.118,8.084a2.5,2.5,0,0,0,.268.381.792.792,0,0,0,1.1.147.8.8,0,0,0,.288-1.077,3.843,3.843,0,0,0-.3-.5q-2.057-3.255-4.114-6.51c-.084-.134-.148-.28-.254-.48.916,0,1.734.018,2.55,0a4.775,4.775,0,0,0,3.834-1.906,17.9,17.9,0,0,0,1.189-2.067c.7,0,1.5,0,2.294,0,.695,0,1.083-.319,1.08-.865s-.378-.856-1.087-.865c-.663-.008-1.325.01-1.987-.013a.523.523,0,0,1-.4-.212c-.345-.864-.655-1.741-.973-2.607,1.05,0,2.2,0,3.347,0,.708,0,1.092-.3,1.1-.843.011-.57-.379-.891-1.12-.892q-5.581-.006-11.161,0c-.691,0-1.1.325-1.118.849-.016.56.389.884,1.127.886,1.305,0,2.611-.014,3.915.008A3.308,3.308,0,0,1-416.956,194.242Z",
    transform: "translate(440.055 -177.844)",
    fill: "#7a7a7a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup6);
export default __webpack_public_path__ + "static/media/Group 6.ca4ed2c6c7eef54660f22d354f490e23.svg";
export { ForwardRef as ReactComponent };